var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['el-divider', ("el-divider--" + _vm.direction)],style:({
    'background-image': _vm.styleMap[_vm.borderStyle],
    'background-size': '8px 1px',
    'background-repeat': 'repeat-x',
  })},[(this.$slots.default && _vm.direction !== 'vertical')?_c('div',{class:['el-divider__text', ("is-" + _vm.contentPosition)]},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }